module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"popular":"Most popular questions on this topic","showMore":"Show more","questions":"question | questions","show":"Hide"}}')
  delete Component.options._Ctor
}
